import { Typography } from '@components'
import { productChannel, useEventBusOn } from '@haus-storefront-react/core'
import { useTranslation } from 'react-i18next'
import styles from './VariantSpecifications.module.scss'

const VariantSpecificationsWidget = () => {
  const { t } = useTranslation()
  const [selectedProductVariant] = useEventBusOn(
    productChannel,
    'product:variant:selected',
    undefined,
    undefined,
    false,
  )

  if (!selectedProductVariant || !selectedProductVariant.customFields?.specifications) {
    return null
  }
  return (
    <table className={styles.root} aria-label={t('a11y.variantSpecifications.aria.tableLabel')}>
      <tbody>
        {selectedProductVariant.customFields?.specifications.map((specification) => (
          <tr key={specification.key} className={styles.row}>
            <th scope="row" className={styles.label}>
              <Typography variant="body" as="span" color="body">
                {specification.key}
              </Typography>
            </th>
            <td className={styles.value}>
              <Typography variant="body" as="span" color="body">
                {specification.value}
              </Typography>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default VariantSpecificationsWidget
